import React from 'react'


const NoStock = ({ color, size }) => {
  return (
    <svg width={size || '16'} height={size || '16'} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8 0C3.57837 0 0 3.57803 0 8C0 12.4217 3.57803 16 8 16C12.4216 16 16 12.422 16 8C16 3.57834 12.422 0 8 0ZM8 14.75C4.26925 14.75 1.25 11.731 1.25 8C1.25 4.26922 4.26897 1.25 8 1.25C11.7308 1.25 14.75 4.26897 14.75 8C14.75 11.7308 11.731 14.75 8 14.75Z'
        fill={color || '#EB2F20'} />
      <path
        d='M10.7373 9.85315L8.8841 7.99997L10.7373 6.14678C10.9814 5.90272 10.9814 5.507 10.7373 5.2629C10.4932 5.01881 10.0975 5.01884 9.85345 5.2629L8.00023 7.11609L6.14701 5.2629C5.90298 5.01881 5.5072 5.01881 5.26313 5.2629C5.01907 5.507 5.01907 5.90272 5.26316 6.14678L7.11635 7.99997L5.26316 9.85315C5.01907 10.0972 5.01904 10.493 5.26313 10.737C5.50729 10.9812 5.90301 10.9811 6.14701 10.737L8.00023 8.88384L9.85345 10.737C10.0974 10.9811 10.4932 10.9811 10.7373 10.737C10.9814 10.4929 10.9814 10.0972 10.7373 9.85315Z'
        fill={color || '#EB2F20'} />
    </svg>


  )
}


export default NoStock

